import {useEffect, useState} from "react";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoCustomSelect, {
    raikoCustomSelectItemGenerator
} from "../../raikoComponents/raikoCustomSelect/RaikoCustomSelect";
import {SliderService} from "../../serverService/sliderService/SliderService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

export default function AddNewSlider({handleCloseDialog, handleAddItem}) {

    const service = new SliderService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getSliderTypesFromServer()
        }
    }, [])

    function getSliderTypesFromServer() {
        loading.show()
        service.getSliderTypes()
            .then(response => {
                setSliderTypesList([])
                response.map((item, index) => {
                    setSliderTypesList(prevState => [
                        ...prevState,
                        raikoCustomSelectItemGenerator(item.key, item.persianName)
                    ])
                })
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست انواع اسلایدر"))
            loading.hide()
        })
    }


    const [sliderTitle, setSliderTitle] = useState("");
    const [sliderType, setSliderType] = useState("");
    const [sliderTypesList, setSliderTypesList] = useState([]);


    function handleAddSlider() {
        if (sliderType.length > 0) {
            loading.show()
            service.addNewSlider(sliderType)
                .then(response => {
                    handleAddItem(response)
                    handleCloseDialog()
                    snackbar.showSuccessMessage("اسلایدر جدید با موفقیت افزوده شد.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در افزودن اسلایدر جدید."))
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا ابتدا دسته بندی مورد نظر را انتخاب کنید.")
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            {/*<RaikoSimpleInputOutlined labelText={"عنوان"} setValue={setSliderTitle} value={sliderTitle}/>*/}
            <RaikoCustomSelect
                labelText={"دسته بندی"}
                setValue={setSliderType}
                items={sliderTypesList}
                value={sliderType}
            />
            <ButtonDivisionSection>
                <ButtonPrimaryRaiko label={"افزودن"} onClick={handleAddSlider}/>
            </ButtonDivisionSection>
        </RaikoGridOneColumn>
    )
}